import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { JobServiceApi } from "../../services";
import * as jobConstants from "../../enums/jobs";

const initialState = {
  userId: 1,
  clientId: 1,
  loading: false,
  error: '',
  slaJobList: [],
  slaJobDescription: '',
  slaListData:[],
  slaMembersList:[],
}

export const fetchSlaJobs = createAsyncThunk('jobs/fetchSlaJobs', (req) => {
  return JobServiceApi.getSlaJobList(req).then(response => {
    console.log("thunk res sla jobs", response?.data)
    return response?.data;
  });
});

export const fetchSlaList = createAsyncThunk('jobs/fetchSlaList', (req) => {
  return JobServiceApi.getSlaListData(req).then(response => {
    console.log("thunk res sla list data", response?.data)
    return response?.data;
  });
});

// export const fetchSlaMembers = createAsyncThunk('jobs/fetchSlaMembers', (req) => {
//   return JobServiceApi.getSlaMemberList(req).then(response => {
//     console.log("thunk res sla member list data", response?.data)
//     return response?.data;
//   });
// });

const slaSlice = createSlice({
  name: 'sla',
  initialState,
  reducers: {
    setSlaJobDescription: (state, action) => {
      state.slaJobDescription = action.payload;
    },
    setSlaJobMember: (state, action) => {
      state.slaMembersList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchSlaJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSlaJobs.fulfilled, (state, action) => {
      console.log("redux res fetchSlaJobs", action.payload);
      state.loading = false;
      state.slaJobList = action?.payload?.data.list;
      state.error = '';
    });

    builder.addCase(fetchSlaJobs.rejected, (state, action) => {
      state.loading = false;
      state.slaJobList = [];
      state.error = action.error.message;
    });

    // For SLA List Data
    builder.addCase(fetchSlaList.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSlaList.fulfilled, (state, action) => {
      console.log("redux res fetchSlaList", action.payload);
      state.loading = false;
      state.slaListData = action?.payload?.data.list;
      state.error = '';
    });

    builder.addCase(fetchSlaList.rejected, (state, action) => {
      state.loading = false;
      state.slaListData = [];
      state.error = action.error.message;
    });

// For SLA Members List
    // builder.addCase(fetchSlaMembers.pending, state => {
    //   state.loading = true;
    // });

    // builder.addCase(fetchSlaMembers.fulfilled, (state, action) => {
    //   console.log("redux res favourite", action.payload);
    //   state.loading = false;
    //   state.slaMembersList = action?.payload?.data;
    //   // state.slaMembersList = [];
    //   state.error = '';
    // });

    // builder.addCase(fetchSlaMembers.rejected, (state, action) => {
    //   state.loading = false;
    //   state.slaMembersList = [];
    //   state.error = action.error.message;
    // });
  }
});

export default slaSlice.reducer;
export const {
  setSlaJobDescription,
  setSlaJobMember,
} = slaSlice.actions;
